import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import { EpisodesList } from 'containers/Podcast/components/EpisodesList';
import { useQuery } from 'react-query';
import { fetchListenNotesData } from 'components/AudioCard';
import LoadingIndicator from 'components/LoadingIndicator';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
  },
  image: {
    width: 60,
    height: 60,
    objectFit: 'cover',
    marginBottom: theme.spacing(1),
  },
  detailsContainer: {
    width: '100%',
  },
  episodeRoot: {
    padding: 0,
    marginTop: 0,

    '& p': {
      whiteSpace: 'normal',
      fontSize: props => props.small && '1rem',
    },
  },
  container: {
    justifyContent: 'center',
  },
}));

export const RecommendedPodcastPreview = ({
  item,
  small,
  trackingProps,
  isDashboard,
}) => {
  const classes = useStyles({ small });

  const [podcastEpisodeSiteCopy] = useSiteCopySelector(['podcast-episodes']);
  const { data, status } = useQuery(
    [
      'listenotes',
      {
        finalType: _get(item, 'fields.type'),
        listenNotesId: _get(item, 'fields.listenNotesId'),
      },
    ],
    fetchListenNotesData,
  );

  const episode = _get(data, 'data.episodes.0') || _get(data, 'data');
  const title = _get(podcastEpisodeSiteCopy, 'pageCopy.title');
  const listenNotes = episode ? [episode] : [];

  return (
    <div className={classes.root}>
      <img
        className={classes.image}
        src={_get(item, 'fields.imageUrl')}
        alt="Podcast"
      />
      <div className={classes.detailsContainer}>
        {status === 'loading' ? (
          <LoadingIndicator />
        ) : (
          <EpisodesList
            customClasses={classes}
            listenNotes={listenNotes}
            podcastEpisodeSiteCopy={podcastEpisodeSiteCopy}
            title={title}
            trackingProps={trackingProps}
            inPage={false}
            eventPrefix={
              isDashboard ? 'Course Dashboard - Resource' : undefined
            }
          />
        )}
      </div>
    </div>
  );
};
